import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { DateRangeSelector } from 'src/core/POS/DateRangeSelector';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import {
  getDisabledDatesForTimeFrameFilter,
  StandardDateRangePresetNames,
  StandardDateRangePresetNamesV2,
} from 'src/utils/dateTimeUtils';
import {
  DateTimeRangeWithRelative,
  EventTimeFrameFilter,
  Feature,
  FilterOperationType,
} from 'src/WebApiController';

export type EventLastReviewedFilter = {
  eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
  eventTimeFrameFilter: EventTimeFrameFilter | null;

  operations?: {
    eventNotReviewedSinceDateOp?: FilterOperationType | null;
  } | null;
};

export const useEventLastReviewedFilters = <
  TFilter extends EventLastReviewedFilter,
>({
  initialQuery,
  tempQuery,
  setTempQuery,
  supportMultiOperation = false,
  isHorizontalLayout = false,
}: {
  initialQuery: TFilter;
  tempQuery: TFilter;
  setTempQuery: (query: TFilter) => void;
  supportMultiOperation?: boolean;
  isHorizontalLayout?: boolean;
}): FilterToolbarItem[] => {
  const hasDateFiltersRelativeExactCustomFeature = useUserHasFeature(
    Feature.DateFiltersRelativeExactCustom
  );

  return [
    {
      filterId: 'eventNotReviewedSinceDate' as FilterToolbarItemId,
      labelContentId: ContentId.EventNotReviewedSince,
      filterQueryKeys: ['eventNotReviewedSinceDate'] as FilterToolbarItemId[],
      filterItem: (
        <DateRangeSelector
          useRelativePresets={
            // This is a deprecated prop. Remove once DateFiltersRelativeExactCustom is GA'ed
            hasDateFiltersRelativeExactCustomFeature ? false : true
          }
          presetNames={StandardDateRangePresetNames}
          exactPresetNames={
            hasDateFiltersRelativeExactCustomFeature
              ? StandardDateRangePresetNamesV2
              : undefined
          }
          trailingPresetNames={
            hasDateFiltersRelativeExactCustomFeature
              ? StandardDateRangePresetNamesV2
              : undefined
          }
          value={tempQuery.eventNotReviewedSinceDate}
          defaultValue={initialQuery.eventNotReviewedSinceDate}
          operation={tempQuery.operations?.eventNotReviewedSinceDateOp ?? null}
          enableOperationSelect={supportMultiOperation}
          isHorizontalLayout={isHorizontalLayout}
          onBlur={({ value, operation }) =>
            setTempQuery({
              ...tempQuery,
              eventNotReviewedSinceDate: value,
              operations: supportMultiOperation
                ? {
                    ...tempQuery.operations,
                    eventNotReviewedSinceDateOp: operation,
                  }
                : undefined,
            })
          }
          disabledDay={(d) =>
            getDisabledDatesForTimeFrameFilter(
              d,
              tempQuery.eventTimeFrameFilter
            )
          }
        />
      ),
    },
  ];
};
